/**
 * useTranslateEnum hook
 * @param {string} enumName
 * @param {string} label
 * @param returnArray
 * @returns {any} lang
 */
export default function useTranslateEnum(enumName: string, label: string = null, returnArray: boolean = false) {
    // add method to lang isLangLoaded
    this.lang.isLangLoaded = () => {
        return !!this.lang?.data && Object.keys(this.lang?.data).length > 0;
    };

    // when used without label, return null
    if (!label && !returnArray) {
        return null;
    }

    if (!this.lang?.data || this.lang?.isLoading || this.lang?.isError) {
        // console.warn('useTranslate >> lang is not loaded yet');
        if (returnArray) {
            return [];
        }
        return label;
    }

    if (returnArray) {
        return this.lang?.data?.[enumName] || [];
    }
    return this.lang?.data?.[enumName]?.[label] || label;
}
